import calculateMargin from "./calculateMargin"
import formatterNumber from "./formatterNumber"

export default function getMargin(
  contractValueUSD: string | undefined | number,
  contractValueCLP: string | undefined | number,
  data: InstrumentData | undefined
) {
  let requiredMargin: string | number = ""

  if (data !== undefined) {
    const margin = parseFloat(data.margin)

    if (contractValueCLP === undefined && contractValueUSD !== undefined) {
      //eslint-disable-next-line
      contractValueUSD = String(contractValueUSD).replace(/\,/g, "")
      const floatContractValueUSD = parseFloat(contractValueUSD)
      requiredMargin = calculateMargin(floatContractValueUSD, margin, 2)

      if (parseInt(String(requiredMargin)) !== requiredMargin) {
        requiredMargin = formatterNumber(2).format(requiredMargin)
      } else {
        requiredMargin = formatterNumber().format(requiredMargin)
      }
    }
    if (contractValueUSD === undefined && contractValueCLP !== undefined) {
      contractValueCLP = String(contractValueCLP).replace(/,/g, "")
      const floatContractValueClp = parseFloat(contractValueCLP)
      requiredMargin = calculateMargin(floatContractValueClp, margin, 0)
      requiredMargin = formatterNumber().format(requiredMargin)
    }
  }

  return requiredMargin
}
